module.exports = "/img/2.svg?c3b201eafe0b80854746f43d7ce4c3ee";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/spinner/img/2.svg
// module id = N0XM
// module chunks = 83